import api from "../../Api";
import { BaseService } from "../../BaseService";


const URL = 'articles/lock';

export class ArticleLockService extends BaseService {
    async fetch(params: any): Promise<any> {
        try {
            return this.handleResponse(await api.post(`${URL}/`, params));
        } catch (e: any) {
            return this.catchHandler(e);
        }
    }

    async get(articleId: number): Promise<any> {
        try {
            return this.handleResponse(await api.get(`${URL}/?article_id=${articleId}`));
        } catch (e: any) {
            return this.catchHandler(e);
        }
    }
}